import BaseModel from '@/orm/models/BaseModel';
import api from '@/api';
import { Request } from '@vuex-orm/plugin-axios';

export default class CrudModel extends BaseModel {
  static state() {
    return {
      ...BaseModel.state(),
      total: 0,
      perPage: 15,
      currentPage: 0,
      lastPage: 0,
    };
  }

  static getMetaData() {
    const {
      total, perPage, currentPage, lastPage,
    } = this.store().state.entities[this.entity];
    return {
      total, perPage, currentPage, lastPage,
    };
  }

  static apiConfig = {
    actions: {
      async index(payload) {
        const request = await this.get(this.model.url.index, {
          params: payload,
        });

        const { meta } = request.response.data;

        await this.model.commit((state) => {
          state.total = meta.total;
          state.perPage = meta.per_page;
          state.currentPage = meta.current_page;
          state.lastPage = meta.last_page;
        });

        return request;
      },
      store(payload) {
        return this.post(`${this.model.url.index}`, payload);
      },
      update({ id, payload }) {
        return this.put(`${this.model.url.index}/${id}`, payload);
      },
      show(id) {
        return this.get(`${this.model.url.index}/${id}`);
      },
      destroy(id) {
        return this.delete(`${this.model.url.index}/${id}`, { delete: true });
      },
    },
  }
}
